import {IUserDataNormalizedClient, IUserDataNormalizedPublic, IUserProfile, IUserProfileBase,} from "../bridge/define";
import {DeprecatedProperties} from "../bridge/define.server";
import {UserCenter} from "../includes/user-center";
import {UserPermissionDict} from "./user-permission-dict";

export class UserInstance<IProfile extends IUserProfileBase = IUserProfile> implements IUserDataNormalizedPublic<IProfile>, DeprecatedProperties {
	private _permissions: UserPermissionDict<IProfile>;
	private uc: UserCenter<IProfile>;
	
	readonly token: string;
	
	readonly username: string;
	readonly email: string;
	readonly profile: IProfile;
	
	readonly id: string;
	readonly updatedAt: Date;
	readonly createdAt: Date;
	
	readonly roles;
	readonly emails;
	
	constructor(private user: IUserDataNormalizedClient<IProfile>, uc: UserCenter<IProfile>) {
		this.hiddenProp('uc', uc);
		
		this.hiddenProp('roles', user['roles'] || []);
		this.hiddenProp('emails', user['emails'] || []);
		
		this.normalProp('id', user.id);
		this.normalProp('username', user.username);
		this.normalProp('email', user.email);
		this.normalProp('profile', user.profile);
		if (user['token']) {
			this.normalProp('token', user['token']);
		} else if (user.userCenterLoginToken) {
			this.normalProp('token', user.userCenterLoginToken);
		}
		
		let {createdAt, updatedAt}:any = user;
		if (typeof createdAt === 'string' || typeof createdAt === 'number') {
			createdAt = new Date(createdAt as any);
		}
		this.normalProp('createdAt', createdAt);
		if (typeof updatedAt === 'string' || typeof updatedAt === 'number') {
			updatedAt = new Date(updatedAt as any);
		}
		this.normalProp('updatedAt', updatedAt);
		
		this._permissions = new UserPermissionDict(user.id, this.uc);
	}
	
	toJSON(): IUserDataNormalizedClient<IProfile> {
		return this.user;
	}
	
	/** @deprecated */
	get userCenterLoginToken() {
		return this.token;
	}
	
	/** @deprecated */
	get _id() {
		return this.id;
	}
	
	get permissions(): UserPermissionDict<IProfile> {
		return this._permissions;
	};
	
	// extra
	get hasLoggedIn(): boolean {
		return !!this.token;
	}
	
	private hiddenProp(name, value) {
		Object.defineProperty(this, name, {
			enumerable: false,
			configurable: false,
			value: value,
		});
	}
	
	private normalProp(name, value) {
		Object.defineProperty(this, name, {
			enumerable: true,
			configurable: false,
			writable: false,
			value: value,
		});
	}
	
	updateProfile(map: Partial<IProfile>) {
		const old = this.profile;
		for (const n in map) {
			if (map[n] == old[n]) {
				delete map[n];
			}
		}
		if (Object.keys(map).length > 0) {
			return this.uc.user.updateProfile(this.token, map);
		} else {
			return Promise.resolve({short: true});
		}
	}
	
	updatePermissionObject(permissions: UserPermissionDict<IProfile>) {
		this._permissions = permissions;
	}
	
	getDisplayName() {
		return this.profile.nickname || this.username;
	}
}
